import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { LatLng } from '../../new-service/interfaces/LongitudeLatitude';
import { FunnelService } from '../../new-service/services/funnel.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { LocationType, VehicleStorage } from '../../new-service/interfaces/VehicleStorage';

@Component({
    selector: 'app-campa-selector',
    templateUrl: './campa-selector.component.html',
    styleUrls: ['./campa-selector.component.scss'],
})
export class CampaSelectorComponent implements OnInit, AfterViewInit {

    @ViewChild('inputFieldAutocomplete1') inputFieldElementRef1!: ElementRef;
    @Input() showPrice = true;
    @Output() selectionChanged = new EventEmitter<VehicleStorage>();
    page = 1;
    pageCount = 0;

    selected_vehicle_storage: VehicleStorage | undefined = undefined;
    autocompleted1_ok = false;
    autocompleteSingleLocation1: google.maps.places.Autocomplete | undefined;
    vehicleStorageLocationType = LocationType.Inside;

    locationSearchVehicleStorage: LatLng = { lat: 0, lng: 0 };

    vehicle_storages: VehicleStorage[] = [];

    constructor(private ngZone: NgZone,
        private cdr: ChangeDetectorRef,
        private funnelService: FunnelService,
        private loader: LoaderService) { }


    ngAfterViewInit(): void {
        this.initializeAutocomplete();
        setTimeout(() => {
        }, 500);
    }

    ngOnInit(): void {
        // this.initializeAutocomplete();
    }

    setPage(page: number) {
        if (this.page != page) {
            this.page = page;
            this.getVehicleStorages();
        }
    }

    prevPage() {
        if (this.page > 1) {
            this.page--;
            this.getVehicleStorages();
        }
    }

    nextPage() {
        if (this.page < this.pageCount) {
            this.page++;
            this.getVehicleStorages();
        }
    }

    get pages() {
        const totalPages = this.pageCount;
        const visiblePages = [];

        for (let i = 1; i <= Math.min(totalPages, 3); i++) {
            visiblePages.push(i);
        }

        if (totalPages > 3) {
            if (totalPages >= 7) {
                visiblePages.push(-1);
            }
            for (let i = Math.max(totalPages - 2, 1); i <= totalPages; i++) {
                if (!visiblePages.includes(i) && i !== -1) {
                    visiblePages.push(i);
                }
            }
        }

        return visiblePages;
    }

    initializeAutocomplete(): void {
        const input = this.inputFieldElementRef1.nativeElement;

        if (!this.autocompleted1_ok && input) {
            // Elimina otros contenedores anteriores
            document.querySelectorAll('.pac-container').forEach((el) => el.remove());

            const autocomplete = new google.maps.places.Autocomplete(input);

            this.autocompleteSingleLocation1 = autocomplete;

            autocomplete.addListener('place_changed', () => {
                this.handlePlaceChanged(autocomplete, this.inputFieldElementRef1);
            });

            this.autocompleted1_ok = true;

            // Observador para esperar que Google cree el dropdown
            const observer = new MutationObserver(() => {
                const container = document.querySelector('.pac-container') as HTMLElement;

                if (container && input) {
                    const rect = input.getBoundingClientRect();

                    container.style.position = 'absolute';
                    container.style.top = `${rect.bottom + window.scrollY}px`;
                    container.style.left = `${rect.left + window.scrollX}px`;
                    container.style.width = `${rect.width}px`;
                    container.style.zIndex = '10000';

                    // 🔥 Aquí movemos el contenedor dentro del modal
                    const dialogContainer = document.querySelector('mat-dialog-container');
                    if (dialogContainer && !dialogContainer.contains(container)) {
                        dialogContainer.appendChild(container);
                    }

                    observer.disconnect(); // Ya está colocado
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        }
    }

    getVehicleStorages() {
        this.vehicle_storages = [];
        //this.loading = true;
        this.loader.show();
        this.funnelService.getVehicleStorages(this.page,
            this.locationSearchVehicleStorage.lat!,
            this.locationSearchVehicleStorage.lng!,
            this.vehicleStorageLocationType === LocationType.Outside).subscribe((ret: any) => {
                this.loader.hide();
                //this.loading = false;
                this.pageCount = ret.PageCount;
                this.vehicle_storages = ret.VehicleStorages.map((c: VehicleStorage): VehicleStorage => ({
                    Id: c.Id,
                    Address: c.Address,
                    InitialPrice: c.InitialPrice,
                    PerDayPrice: c.PerDayPrice,
                    ExtraPrice: c.ExtraPrice,
                    IsCover: c.IsCover,
                    City: c.City,
                    Coordinates: c.Coordinates,
                    Name: c.Name,
                }));
            });
    }

    selectVehicleStorageType(type: number): void {
        this.vehicleStorageLocationType = type;
        if (this.autocompleted1_ok) {
            this.getVehicleStorages();
        }
    }

    private handlePlaceChanged(
        autocomplete: google.maps.places.Autocomplete,
        elementRef: ElementRef
    ): void {
        this.ngZone.run(() => {
            const place = autocomplete.getPlace();
            if (!place.address_components) return;

            const address = place.formatted_address as string;
            const location = place.geometry?.location?.toJSON() as LatLng;
            this.locationSearchVehicleStorage = location;
            this.getVehicleStorages();
            this.cdr.detectChanges();
        });
    }

    is_checked(vehicleStorage: VehicleStorage) {
        return this.selected_vehicle_storage?.Id === vehicleStorage.Id;
    }

    selectVehicleStorage(vehicleStorage: VehicleStorage) {
        if (this.selected_vehicle_storage?.Id === vehicleStorage.Id) {
            this.selected_vehicle_storage = undefined;
            this.selectionChanged.emit(undefined);
            return;
        }
        this.selected_vehicle_storage = vehicleStorage;
        const match = vehicleStorage.Coordinates.match(/POINT \(([-\d.]+) ([-\d.]+)\)/);

        if (match) {
            const longitude = parseFloat(match[1]);
            const latitude = parseFloat(match[2]);

            this.selected_vehicle_storage.Latitude = latitude;
            this.selected_vehicle_storage.Longitude = longitude;
        } else {
        }


        // 1 --> inside | 2 --> outside
        // const productType = vehicleStorage.isCover ? 1 : 2;
        // const vehicleStorageId = vehicleStorage.id;
        // const vehicleStorageName = vehicleStorage.name;

        this.selectionChanged.emit(this.selected_vehicle_storage);
    }
}